import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Emoji from "./Emoji";
import axios from "axios";

import routes from "../../../../app/routes";

export default function Feedback({ step, nextSlide, skip, skipping }) {
  const [rate, setRate] = useState(0);
  const [comment, setComment] = useState("");
  const [useful, setUseful] = useState(0);

  const [submitting, setSubmitting] = useState(false);

  const saveFeedback = () => {
    if (submitting) {
      return;
    }
    if (rate == 0) {
      swal({
        title: "",
        text: "We'd love to know what you think! Please select an emoji before proceeding to the next step.",
        type: "warning",
      });
      return;
    }

    setSubmitting(true);

    const prepareUsefull = () => {
      let answer = null;
      switch (useful) {
        case 1:
          answer = true;
          break;
        case 2:
          answer = false;
          break;
      }
      return answer;
    };

    axios
      .post(routes.api.steps.session.feedback(step.step.id), {
        session_feedback: {
          rate: rate,
          comment: comment,
          useful_module: prepareUsefull(),
        },
      })
      .then((resp) => {
        nextSlide();
      });
  };

  return (
    <Modal.Body className="white-background height100">
      <h2>
        How did you feel about the coaching session '{step.session_name}' with
        coach {step.coach} ?
      </h2>
      <p className="mt20 mb20">
        Please select the emoji that represents the best your reaction after the
        session.
      </p>
      <Emoji selectedPosition={rate} setRate={setRate} />
      <div className="mt20 form-group">
        <textarea
          className="form-control"
          rows="8"
          placeholder="Private Comment"
          onChange={(e) => setComment(e.target.value)}
          value={comment}
        />
      </div>
      <div className="mt30 form-group without-check-icon">
        <p>Did you find your session about {step.session_name} useful?</p>
        <div className="row mt10">
          <div className="col-sm-4 col-sm-offset-2 text-right pr10">
            <div className="answer mt10">
              <div
                onClick={() => setUseful(1)}
                className={`btn btn-round learning-style-btn text-in-one-string ${
                  useful == 1 ? "btn-blue" : "btn-green btn-outline"
                }`}
              >
                Yes
              </div>
            </div>
          </div>
          <div className="col-sm-4 text-left pl10">
            <div className="answer mt10">
              <div
                onClick={() => setUseful(2)}
                className={`btn btn-round learning-style-btn text-in-one-string ${
                  useful == 2 ? "btn-blue" : "btn-green btn-outline"
                }`}
              >
                No
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-md-6">
          {!submitting && (
            <a
              className="btn btn-green btn-outline"
              onClick={() => skip({ ids: [step.id], type: "session_feedback" })}
            >
              {skipping ? "Please, wait ..." : "Skip"}
            </a>
          )}
        </div>
        <div className="col-md-6 text-right">
          {!skipping && (
            <button
              type="submit"
              className="btn btn-primary submit-button"
              onClick={saveFeedback}
            >
              {submitting ? "Please, wait ..." : "Next"}
            </button>
          )}
        </div>
      </div>
    </Modal.Body>
  );
}
